import { render, staticRenderFns } from "./SalesReports.vue?vue&type=template&id=4a82b6ae"
import script from "./SalesReports.vue?vue&type=script&lang=js"
export * from "./SalesReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports